import { createContext, useContext } from 'react';

const ProjectManager = createContext({
  projectDetails: null,
  currentTab: null,
  mode: '',
  setProjectDetails: () => {},
  setCurrentTab: () => {},
  fetchProjectsInBg: () => {},
  onClose: () => {},
});

ProjectManager.displayName = 'ProjectManager';

export const useProjectManager = () => {
  const ProjectManagerContext = useContext(ProjectManager);
  return ProjectManagerContext;
};

export const ProjectProvider = ProjectManager.Provider;
